
import { defineComponent, watch, ref } from 'vue'
import { useRouter } from 'vue-router'
import { AxiosResponse } from 'axios'

import MessageAttacheFiles from '@/components/inputs/MessageAttacheFiles.vue'
import JrTextarea from '@/components/jr-parts/JrTextarea.vue'
import InputLabel from '@/components/inputs/InputLabel.vue'

import { MessageWithAttached } from '@/api'
import { MessageForm } from '@/types/forms'
import Logger from '@/services/logger'
import { ReadRequest } from '@/requests/message'
import MessageTypeLogic from '@/services/messageTypeLogic'

/**
 * 申請者側メッセージ取得・表示
 * 取得したメッセージはemitする
 * 不正な種別の場合、404画面に遷移する
 */
export default defineComponent({
  name: 'ApplicantMessageView',
  components: {
    MessageAttacheFiles,
    JrTextarea,
    InputLabel,
  },
  emits: ['update:message'],
  props: {
    // 申請基本
    requestHeaderId: {
      type: Number,
      required: false,
      default: null,
    },
    // メッセージ種別
    messageType: {
      type: Number,
      required: false,
      default: null,
    },
    // メッセージID
    messageId: {
      type: Number,
      required: false,
      default: null,
    },
    // 添付ファイル欄表示フラグ
    attacheFilesAreaVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    const router = useRouter()
    const canAttached = ref<boolean>(false)
    const message = ref<MessageForm | null>(null)

    watch(
      () => [props.requestHeaderId, props.messageType, props.messageId],
      async () => {
        // 初期化
        message.value = null
        if (props.requestHeaderId == null || props.messageType == null || props.messageId == null) {
          // どれかがnullなら何もしない(親コンポーネントで404とする)
          return
        }
        // 取得
        const request = new ReadRequest(props.messageId)
        await request.exec()
        if (request.success) {
          const { data } = request.getResponse() as AxiosResponse<MessageWithAttached>
          if (data.request_header !== props.requestHeaderId) {
            Logger.info(
              `メッセージと申請基本IDが異なります。 prop: ${props.requestHeaderId} 受信: ${data.request_header}`
            )
            router.push({ name: 'NotFound' })
            return
          }
          if (data.message_type !== props.messageType) {
            Logger.info(`メッセージと種別が異なります。 prop: ${props.messageType} 受信: ${data.message_type}`)
            router.push({ name: 'NotFound' })
            return
          }
          // 添付ファイル許可種別を取得
          const logic = new MessageTypeLogic(props.messageType, props.requestHeaderId)
          canAttached.value = logic.canAttachedFile()

          // メッセージを保持、emit
          message.value = data as MessageForm
          context.emit('update:message', data)
        }
      },
      { immediate: true, deep: true }
    )
    return {
      canAttached,
      message,
    }
  },
})
